import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function Slider() {

    const options = {
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplaySpeed: 1000,
        animateOut: 'fadeOut', // Use 'fadeOut' animation for fading out items
        onChanged: handleSlideChange,
        dots: false,
      };
    
      function handleSlideChange(event) {
        console.log('Active item:', event.item.index);
      }
  return (
    <div className="banner-wrapper pb-4 pt--lg-100 dark-bg posr" style={{background: 'linear-gradient(180deg, #cef2ff, #fff)'}}>
    <div className="banner-pattern">
      <img src="images/pattern-2.png" alt="pattern" className="ani4 pattern1" />
      <img src="images/pattern-1.png" alt="pattern" className="ani2 pattern2" />
      <img src="images/pattern-1.png" alt="pattern" className="ani4 pattern3" />
      <img src="images/pattern-2.png" alt="pattern" className="ani2 pattern4" />
      <img src="images/pattern-2.png" alt="pattern" className="ani4 pattern5" />
      <img src="images/pattern-3.png" alt="pattern" className="ani3 pattern6" />
    </div>
    <div className="container py-xl-5">
      <div className="row justify-content-between">
        <div className="col-lg-6 col-md-7 mt-md-4 md-mb-3">
          <h1 className="display5-size lh-1 text-gray-900 dark-text rajdhani-700">Discover the world of <span className="bg-no-repeat bg-image-center bg-image-contain p-2 pt-3" style={{backgroundImage: 'url(images/text-bg-3.png)'}}>Avatar</span> 
          {/* <span className="bg-no-repeat bg-image-center bg-image-contain p-2 pt-3" style={{backgroundImage: 'url(images/text-bg-3.png)'}}> NFT’s</span>*/}</h1> 
          <div className="d-flex flex-row gap-3">
            {/* <div className="w-150">
              <OwlCarousel className="owl-theme ovh nft-bg-fade mt-3" {...options}>
                <div className="item h-76 w-150 rounded-pill" style={{backgroundImage: 'url(images/nft-bg-1.png)'}} />
                <div className="item h-76 w-150 rounded-pill" style={{backgroundImage: 'url(images/nft-bg-2.png)'}} />
              </OwlCarousel>
            </div> */}
            <p className="rajdhani-600 dark-text h6 lh-28 text-gray-900 w-md-75 mt-2 pe-md-5">Reach more than 20M players. Customize with hundreds of options. Connect with fans and reach new global audiences.</p>
          </div>
          <div className="d-flex flex-row gap-3 mt-4">
            <a href="#" className="btn btn-lg text-white rajdhani-600 rounded-6 bg-gray-900 border-dark border-2 px-lg-5 font-sm text-uppercase top-slider-btn">Create your avatar</a>
            <a href="#" className="btn btn-lg text-gray-900 rajdhani-700 rounded-6 bg-current border-current border-2 px-lg-5 font-sm text-uppercase top-slider-btn">Rent avatar</a>
          </div>
        </div>
        <div className="col-lg-5 col-md-5 ps-md-4 posr">
          <img src="images/avatar_one.gif" alt="banner" className="img-fluid " />
          <div className="position-absolute top-50 start-0 translate-middle"><img src="images/round-text-2.png" alt="icon" className="w-110 rotate-circle" /></div>
        </div>
      </div>
    </div>
    <div className="container feedback-top">
      <div className="row">
        <div className="col-lg-8">
          <div className="feature-div bg-darkblack p-5 rounded-6 shadow-xss">
            <h6 className="text-cyan rajdhani-600 font-sm text-uppercase ls-4 mb-4">Client feedback</h6>
            <div className="carousel pt-4">
              <i className="bi-quote display3-size text-gray-600 position-absolute top-n3 lh-32 ms-n3" />
              <OwlCarousel className="owl-theme nft-bg-fade ms-3" {...options}>
                <div className="item"><h4 className="rajdhani-500 text-white">Avatar Lab isn't just about crafting cute avatars; it's a secret weapon for me to earn passive income. I've turned my creations into stickers, and they've become a hit in no time!</h4></div>
                <div className="item"><h4 className="rajdhani-500 text-white">As a side hustle enthusiast, Avatar Lab has been a game-changer. I've transformed my avatar designs into digital merchandise, and the passive income is a sweet bonus!</h4></div>
              </OwlCarousel>
            </div>
            <div className="d-flex flex-row justify-content-between mt-4">
              <div className="d-flex justify-content-start w-50 gap-2">
                <h2 className="rajdhani-700 text-white lh-1 mb-0 display1-size">4.8</h2>
                <div className="d-flex flex-column">
                  <div className="d-flex flex-row gap-1 mt-1">
                    <i className="bi-star-fill text-warning font-sm" />
                    <i className="bi-star-fill text-warning font-sm" />
                    <i className="bi-star-fill text-warning font-sm" />
                    <i className="bi-star-fill text-warning font-sm" />
                    <i className="bi-star-half text-warning font-sm" />
                  </div>
                  <h4 className="rajdhani-600 font-sm lh-18 text-gray-200">32k people feedback</h4>
                </div>
              </div>
              <div className="d-flex flex-row gap-3">
                <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-51" /></figure>
                <h6 className="rajdhani-600 lh-22 mt-1  text-white">Ape Kennel Club <span className="d-block rajdhani-500 font-xs text-gray-500">@nobita_thumbson</span></h6>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 lg-mt-3">
          <div className="feature-div bg-white p-5 rounded-6 shadow-xss">
            <img src="images/lock-dark.svg" alt="box" className="ms-n1 mt-n1 mb-3" />
            <h2 className="rajdhani-600 h4 mt-2">The Future of <br />Metaverse Fashion is Here</h2>
            <p className="rajdhani-600 font-sm mb-0">Are you ready to redefine your digital style? The next era of virtual fashion has arrived. Welcome to a world where you can seamlessly sell your unique fashion creations across thousands of games, reaching over 20 million players.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}
